import {
    Alert,
    Box,
    Card, CardContent,
    Checkbox, FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText, FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Table,
    TableBody, TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from "@deere/fuel-react";
import React, { useState } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { useTranslation } from "react-i18next";
import "../../assets/css/Sections.css";
import "../../assets/css/TpsStyles.css";
import FuelTable from "../../components/FuelTable";
import LinearProgressIndicator from "../../components/LineProgressIndicator";
import { PartsTable } from "../../components/coo/PartsTable";
import { SuppliersTable } from '../../components/coo/SuppliersTable';
import { useUserInfo } from '../../providers/userProvider';
import {
    COO_COMPONENT_CODE_SECTIONS,
    DEFAULT_GRID_COLLUMNS,
    EMPTY_BODY, SECTION_TYPES,
} from '../../utils/surveyLiterals';
import { containsCheckBoxAnswer, findAnswerIndex, findSelectionIndex, getLDTranslation, getTranslation, getRequestStatusWhenCampaignClosed } from '../../utils/utils';
import { showInputTextErorr, showTablesError } from '../../utils/validation';
import { getValidator } from '../../utils/validationRequiredFactory';
import { GenericFuelModal } from "../../components/modals/GenericFuelModal";

function shouldRender(question, answers, review, questions) {
    let shouldRender = true;
    if (review) { return shouldRender }
    if (question.idQuestionDepends !== null && question.idSelectionDependson !== null) {
        shouldRender = false;
        let answerQuestion = answers ? answers.find(ans => parseInt(ans.questionId) === parseInt(question.idQuestionDepends)) : null;
        if (question.regexp === "notdepends") {
            if (answerQuestion && answerQuestion.answer && !answerQuestion.answer.toString().includes(question.idSelectionDependson.toString())) {
                shouldRender = true;
            }
        } else {
            if (answerQuestion && answerQuestion.value && answerQuestion.value.toString() === question.idSelectionDependson.toString())
                shouldRender = true;

            if (answerQuestion && answerQuestion.answer && answerQuestion.answer.toString() === question.idSelectionDependson.toString())
                shouldRender = true;

            if (shouldRender === true) {
                // Validating grand parent question
                let parentQuestion = questions.find(ques => parseInt(ques.id) === parseInt(question.idQuestionDepends));
                if (parentQuestion && parentQuestion.idQuestionDepends !== null && parentQuestion.idSelectionDependson !== null) {
                    let answerQuestionParent = answers.find(ans => parseInt(ans.questionId) === parseInt(parentQuestion.idQuestionDepends));
                    if (!answerQuestionParent || answerQuestionParent.answer.toString() !== parentQuestion.idSelectionDependson.toString()) {
                        shouldRender = false;
                    }
                }
            }
        }
    }

    return shouldRender;
}

export default function Section({
    survey,
    section,
    review,
    questionsToValidate,
    campaign,
    isSubmit,
    setIsSubmitted,
    cooResponses,
    resetForm,
    opcSelected,
    agreementQuestionIds,
    cooData,
    pushAnswer,
    popAnswer,
    pushResponseName,
    updatePartsArray,
    updateSuppliersArray,
    selectionModel,
    setSelectionModel,
    editedPartCountries,
    setEditedPartCountries
}) {
    const { t } = useTranslation();
    const headers = ['', t('coo_lbl_upload_collumn_response_name'),
        t('coo_lbl_upload_collumn_parts_dec'),
        t('coo_lbl_upload_collumn_tmstmp'),
        t('coo_lbl_upload_collumn_updated_by'),
        t('coo_lbl_upload_collumn_status'), '']
    const questions = section.questions.filter(qu => qu.active).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
    const requiredValidator = getValidator(survey.code);
    const answers = Array.isArray(cooData?.answers) ? cooData.answers : [];
    const suppliersTable = Array.isArray(cooData?.suppliers) ? cooData.suppliers : [];
    const partsData = Array.isArray(cooData?.parts) ? cooData.parts : [];
    const responseName = cooData?.responseName ? cooData.responseName : '';
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState(null);
    const userInfo = useUserInfo();
    let handleModalAction;

    if (!section)
        return EMPTY_BODY;


    const showSelectionModal = (questionSelections, value) => {
        if (questionSelections) {
            let selectionIdx = value !== "" && value ? findSelectionIndex(value, questionSelections) : -1;
            let selection = selectionIdx >= 0 ? questionSelections[selectionIdx] : null
            if (selection && selection.popupKey) {
                setModalMessage(t(`${selection.popupKey}`))
                handleModalAction = () => setShowModal(false);
                setShowModal(true);
            }
        }
    }

    const updateAnswer = (e, questionId, isCountry, questionSelections) => {
        setIsSubmitted(false);
        pushAnswer(questionId, e.target ? e.target.value : e, isCountry, agreementQuestionIds);
        showSelectionModal(questionSelections, e.target ? e.target.value : e);
    }
    const updateCheckAnswer = (e, question) => {
        setIsSubmitted(false);
        let questionIndex = findAnswerIndex(question.id, answers);
        questionIndex >= 0 ? popAnswer(question.id) : pushAnswer(question.id, e.target ? e.target.value : null)
    }

    function createRadioSection(question) {
        let indx = findAnswerIndex(question.id, answers);
        let answer = indx >= 0 ? answers[indx].answer : -1;
        let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, question.selections) : -1;
        let selection = selectionIdx >= 0 ? question.selections[selectionIdx] : null
        let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;
        let questionSelections = question.selections;

        return shouldRender(question, answers, review, questions) && <FormControl fullWidth>
            {
                review ?
                    <Box key={`b-${question.id}`}>
                        <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} paddingLeft={question.idQuestionDepends ? '1.5rem' : ''} fontWeight="semibold" >
                            {getTranslation(question, 'text')}
                        </Typography>
                        <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`} paddingLeft={question.idQuestionDepends ? '1.5rem' : ''}>
                            {selection !== null ? getTranslation(selection, 'text') : ''}
                        </Typography>
                    </Box>
                    : <FormControl sx={{ m: 3 }} variant="standard" error={isError} >
                        <FormLabel>
                            <Typography size="sm" component="p" gutterBottom key={`${question.questionId}`} fontWeight="semibold">
                                {getTranslation(question, 'text')}
                            </Typography>
                        </FormLabel>
                        <RadioGroup name={`radioGroup-${question.id}`} id={`radioGroup-${question.id}`} row required>
                            {question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                                i.active ? <FormControlLabel
                                    sx={{
                                        paddingLeft: question.idQuestionDepends ? 4 : 0,
                                        alignItems: 'start',
                                        "& .MuiStack-root": {
                                            display: "flex",
                                            flexDirection: "row",
                                        }
                                    }}
                                    control={<Radio required={required !== undefined && required !== null ? required : question.required} />}
                                    value={i.value}
                                    id={i.id}
                                    key={i.id}
                                    label={<FormHelperText><Typography paragraph sx={{ textAlign: 'justify', whiteSpace: 'pre-wrap' }}>{getTranslation(i, 'text')}</Typography></FormHelperText>}
                                    name={`${getTranslation(section, 'description')}-${question.id}`}
                                    onChange={(e) => updateAnswer(e, question.id, false, questionSelections)} data-testid={i.id}
                                    checked={indx >= 0 && answer && answer === i.value} />
                                    : ''
                            )}
                        </RadioGroup>
                        {
                            isError ? <FormHelperText>{t('bs_required')} </FormHelperText> : null
                        }
                    </FormControl>
            }
        </FormControl>
    }

    function createCheckSection(question) {
        let indx = findAnswerIndex(question.id, answers);
        let answer = indx >= 0 ? answers[indx].answer : ''
        let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;

        return shouldRender(question, answers, review, questions) && <>
            <Typography size="sm" component="p" gutterBottom fontWeight="semibold" key={`q${question.questionId}`}>
                {getTranslation(question, 'text')}
            </Typography>
            {
                <div id={question.questionId}>
                    <>
                        {
                            review ?
                                question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                                    (i.active && answer === i.value.toString()) ?
                                        <div key={i.id}>
                                            <Typography size="sm" component="p" gutterBottom key={i.id}> {i !== null ? getTranslation(i, 'text') : ''}</Typography>
                                            <br />
                                        </div>
                                        : ''
                                )
                                : question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                                    (i.active) ?
                                        <FormControl
                                            error={isError}>
                                            <FormLabel></FormLabel>
                                            <FormGroup required={required !== undefined && required !== null ? required : question.required} error={isError}>
                                                <FormControlLabel
                                                    control={<Checkbox name={`${getTranslation(section, 'description')}-${question.id}`} />}
                                                    sx={{
                                                        alignItems: 'start'
                                                    }}
                                                    value={i.value}
                                                    id={i.id}
                                                    key={i.id}
                                                    label={getTranslation(i, 'text')}
                                                    name={`${getTranslation(section, 'description')}-${question.id}`}
                                                    onChange={(e) => updateCheckAnswer(e, question, i.exclusive)}
                                                    data-testid={i.id}
                                                    checked={containsCheckBoxAnswer(i.value, answer)}
                                                />
                                            </FormGroup>
                                            {
                                                isError ? <FormHelperText> {t('bs_required')}</FormHelperText> : null
                                            }
                                        </FormControl>

                                        : ''

                                )
                        }
                    </>
                </div>
            }
        </>
    }

    function createTextArea(question) {
        let indx = findAnswerIndex(question.id, answers);
        let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        return shouldRender(question, answers, review, questions) && <>
            <Typography size="sm" component="p" gutterBottom key={`${question.questionId}`} fontWeight="semibold">
                {getTranslation(question, 'text')}
            </Typography>
            {
                review ?
                    <div key={question.questionId}>
                        <Typography size="sm" component="p" gutterBottom key={question.questionId}>{indx >= 0 ? answers[indx].answer : ''}</Typography>
                    </div>
                    :
                    <>

                        <DebounceInput required={required !== undefined && required !== null ? required : question.required}
                            element="textarea" rows="2" aria-describedby="textarea-text" className="form-control" debounceTimeout={300}
                            onChange={(e) => updateAnswer(e, question.id)}
                            value={indx >= 0 ? answers[indx].answer : ''}
                            name={`${getTranslation(section, 'description')}-${question.id}`} />
                    </>
            }
        </>
    }

    function createInput(question) {
        let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        let indx = findAnswerIndex(question.id, answers);
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;
        return shouldRender(question, answers, review, questions) && <>
            {
                review ?
                    <>
                        <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} fontWeight="semibold">
                            {getTranslation(question, 'text')}
                        </Typography>
                        <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`}>
                            {indx >= 0 ? answers[indx].answer : ''}
                        </Typography>
                    </>
                    :
                    <>
                        <TextField
                            required={required !== undefined && required !== null ? required : question.required}
                            onChange={(e) => updateAnswer(e, question.id)}
                            value={indx >= 0 ? answers[indx].answer : ''}
                            name={`${getTranslation(section, 'description')}-${question.id}`}
                            error={isError}
                            variant="outlined"
                            helperText={isError ? t('bs_required') : ''}
                            label={getTranslation(question, 'text')} />

                    </>
            }
        </>
    }

    function createInputName() {
        const required = review ? false : true;
        const name = responseName ? responseName : null;
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? !responseName && responseName.length <= 0 : false;
        return <>
            {
                review ?
                    <>
                        <Typography size="sm" component="p" gutterBottom key={`lbl-${t('coo_lbl_survey_response_name')}`} fontWeight="semibold">
                            {t('coo_lbl_survey_response_name')}
                        </Typography>
                        <Typography size="sm" component="p" gutterBottom key={t('coo_lbl_survey_response_name')}>
                            {name ? name : ''}
                        </Typography>
                    </>
                    : <>
                        <TextField
                            required={required}
                            onChange={(e) => pushResponseName(e.target.value)}
                            value={name ? name : ''}
                            name={`${getTranslation(section, 'description')}-`}
                            error={isError}
                            variant="outlined"
                            helperText={isError ? t('bs_required') : ''}
                            label={t('coo_lbl_survey_response_name')}
                            key={t('coo_lbl_survey_response_name')}
                        />

                    </>
            }
        </>
    }

    function createDateSection(question) {
        const indx = findAnswerIndex(question.id, answers);
        const answer = indx >= 0 ? answers[indx].answer : null;
        const isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;

        return shouldRender(question, answers, review, questions) && <>
            {review ?
                answer && <>
                    <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} fontWeight="semibold">
                        {getTranslation(question, 'text')}
                    </Typography>
                    <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`}>
                        {answer ? answer : ''}
                    </Typography>
                </>
                : <>
                    <FormGroup className="pl-4  col-12">
                        <TextField type="date" required id={question.id}
                            label={getTranslation(question, 'text')}
                            value={answer ? answer : ''}
                            onChange={e => {
                                updateAnswer(e.target.value, question.id)
                            }
                            }
                            name={`${getTranslation(section, 'description')}-${question.id}`}
                        />
                        <div className="invalid-feedback">{t('bs_required')}</div>
                    </FormGroup>
                    {
                        isError ? <FormHelperText error={isError}> {t('bs_required')}</FormHelperText> : null
                    }
                </>
            }
        </>
    }

    function renderParts() {
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showTablesError(suppliersTable, partsData, true) : false;
        const tmpParts = [];
        if (review && cooData && cooData.parts) {
            cooData.parts.forEach((part) => {
              let index = tmpParts.findIndex((i) => i.id === part.id);
              if (index === -1) tmpParts.push(part);
              else tmpParts[index] = {...tmpParts[index], country: tmpParts[index].country+", "+part.country};
            });
          }
        return review && tmpParts.length > 0 ?
            <Grid item md={12}>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('parts_tbl_column_header_1')}</TableCell>
                                <TableCell>{t('parts_tbl_column_header_2')}</TableCell>
                                <TableCell>{t('parts_tbl_column_header_3')}</TableCell>
                                <TableCell>{t('parts_tbl_column_header_10')}</TableCell>
                                <TableCell>{t('parts_tbl_column_header_6')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                tmpParts.map((row) =>
                                    <TableRow key={`rp-${row.id}`}>
                                        <TableCell align="left">{row.supplierNumber}</TableCell>
                                        <TableCell align="left">{row.deerePartNumber}</TableCell>
                                        <TableCell align="left">{row.deerePartDesc}</TableCell>
                                        <TableCell align="left">{row.unitCd}</TableCell>
                                        <TableCell align="left">{row.country}</TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            :
            <>
                <Grid item xs={6} md={12}>
                    <PartsTable campaign={campaign} suppliers={cooData.suppliers} updatePartsArray={updatePartsArray} partsInResponse={cooData.parts} selectedResponseId={cooData.id} selectionModel={selectionModel} setSelectionModel={setSelectionModel} editedPartCountries={editedPartCountries} setEditedPartCountries={setEditedPartCountries}/>
                </Grid>
                <Grid item xs={6} md={12}>
                    {
                        isError ? <Alert variant={"error"}> {t('bs_required')}</Alert> : null
                    }
                </Grid>
            </>
    }

    function getCollumnsByQuestion(questions, questionsGroup) {
        const questionsInGroup = questions.filter(q => q.questionsGroup === questionsGroup);
        return questionsInGroup ? (DEFAULT_GRID_COLLUMNS / questionsInGroup.length) : DEFAULT_GRID_COLLUMNS;
    }

    const questionsComponents = questions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((q) => {

        const collumnsByQuestion = q.questionsGroup ? getCollumnsByQuestion(questions, q.questionsGroup) : DEFAULT_GRID_COLLUMNS;
        return <Grid key={`gq-${q.id}`} item md={collumnsByQuestion} >
            <div style={{ padding: 10, paddingLeft: q.idQuestionDepends ? '1.5rem' : 10, paddingTop: 6, paddingBottom: 7 }}>
                {q.type === 'RADIO' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                {q.type === 'CHECK' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCheckSection(q) : <></>}
                {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createTextArea(q) : <></>}
                {q.type === 'OPEN_SMALL' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createInput(q) : <></>}
                {q.type === 'DATE' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createDateSection(q) : <></>}
            </div>
        </Grid>
    });

    function renderSupplier() {
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showTablesError(suppliersTable, partsData, false) : false;
        const tmpAssignments = review && cooData ? cooData.assignments : null;
        return review ?
            <>
                <Grid item xs={6} md={4} sx={{ paddingBottom: "12px", paddingLeft: "10px" }}>
                    {createInputName()}
                </Grid>
                <Grid item md={12}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("parts_tbl_column_header_1")}</TableCell>
                                    <TableCell>{t("t2_supplier_name")}</TableCell>
                                    <TableCell>{t("lbl_Request_Number")}</TableCell>
                                    <TableCell>{t("coo_lbl_upload_collumn_status")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    tmpAssignments ? tmpAssignments.map((row) =>
                                        <TableRow key={`rp-${row.id}`}>
                                            <TableCell align="left">{row.supplierNumber}</TableCell>
                                            <TableCell align="left">{row.supplierName}</TableCell>
                                            <TableCell align="left">{row.id}</TableCell>
                                            <TableCell align="left">{campaign ? getRequestStatusWhenCampaignClosed(row.status, campaign.status) : ""}</TableCell>
                                        </TableRow>
                                    )
                                        : ''
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </>
            : <>
                <Grid item xs={6} md={8} sx={{ paddingBottom: "12px", paddingLeft: "10px" }}>
                    {createInputName()}
                </Grid>
                <Grid item xs={6} md={12}>
                    <SuppliersTable campaign={campaign} suppliers={cooData.suppliers} updateSuppliersArray={updateSuppliersArray} />
                </Grid>
                <Grid item xs={6} md={12}>
                    {
                        isError ? <Alert variant={"error"}> {t('bs_required')}</Alert> : null
                    }
                </Grid>
            </>
    }

    function renderResponseSection() {
        if (cooResponses) {
            return <Grid item xs={6} md={12}>
                <RadioGroup name="selectedCustom" value={opcSelected}><FuelTable headers={headers} data={cooResponses ? cooResponses : []} resetForm={resetForm} /></RadioGroup>
            </Grid>;
        } else {
            return <Grid item xs={6} md={12}>
                <LinearProgressIndicator title='Loading responses' subtitle='This will take a couple of seconds' />
            </Grid>
        }
    }

    function shouldDisplay(section) {
        if (COO_COMPONENT_CODE_SECTIONS.RESPONSES_SEC !== section.code) {
            return true;
        };
        if (Array.isArray(cooResponses) && cooResponses.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    function renderAuthorizerSection() {
        return <CardContent className='pl-0'>
            <FormLabel className='pl-2' >User:  {userInfo.firstName}, {userInfo.lastName} {userInfo.userID}</FormLabel>
            {questionsComponents}
        </CardContent>
    }

    function renderSection(section) {
        if ((section.type && SECTION_TYPES.includes(section.type.trim().toUpperCase())) || COO_COMPONENT_CODE_SECTIONS.AGREEMENT_SEC === section.code || COO_COMPONENT_CODE_SECTIONS.RESPONSES_SEC === section.code || COO_COMPONENT_CODE_SECTIONS.AUTHORIZER_SEC === section.code) {
            switch (section.code) {
                case COO_COMPONENT_CODE_SECTIONS.SUPPLIERS_SEC: return renderSupplier();
                case COO_COMPONENT_CODE_SECTIONS.PARTS_SECTIONS: return renderParts();
                case COO_COMPONENT_CODE_SECTIONS.RESPONSES_SEC: return renderResponseSection();
                case COO_COMPONENT_CODE_SECTIONS.AUTHORIZER_SEC: return renderAuthorizerSection();
                default: return null;
            }
        }

        return questionsComponents;
    }

    return shouldDisplay(section) ?
        <>
            <Card>
                <CardContent id={section ? section.description : ''} >
                    <Typography gutterBottom variant="h2">
                        {getTranslation(section, 'description')}
                    </Typography>
                    <Typography gutterBottom variant="subtitle1" >{getLDTranslation(section, 'longDescription')}</Typography>
                    <Grid container>
                        {
                            renderSection(section)
                        }
                        {
                            showModal ?
                                <>
                                    <GenericFuelModal show={showModal}
                                        handleClose={setShowModal}
                                        primaryButton={t('btn_close')}
                                        handleSave={handleModalAction}
                                        message={modalMessage}
                                        title={t('coo_lbl_caution')}
                                    />
                                </>
                                : null
                        }

                    </Grid>
                </CardContent>
            </Card>
            <br />
        </> : ''
}
